<template>
  <div class="bg-primary w-100 flex items-center justify-between">
    <div class="flex items-center bg-primary">
      <div class="flex items-center justify-center flex-start" :class="{'image-container': !inHome, 'home-image-container': inHome}">
        <img class="mw-100 h-100" :src="picture">
      </div>
      <div class="pl3-l pr3-l pl1 pr1 flex items-center">
        <div class="flex items-center">
          <span class="light-silver" :class="{'f-subheadline-ns f3 ml2': !inHome, 'f3-ns f5': inHome}">#</span><span
          class="light-silver f-headline-ns f2" :class="{'f-headline-ns f2': !inHome, 'f2-ns f4': inHome}">{{ index + 1 }}</span>
        </div>
        <div :class="{'artist-info': !inHome, 'artist-info-home': inHome}">
          <router-link :to="{ name:'artist-info', params: { id: artist.id }}" class="no-underline" :class="{'primary': !inHome, 'accent': inHome}">
            <artist-data :artist="artist" :isFirstArtist="true" :inHome="inHome"></artist-data>
          </router-link>
        </div>
      </div>
    </div>
    <div  :class="{'db-ns dn': !inHome, 'dn': inHome}">
      <circle-progress :percent="artist.percent" emptyFill="rgba(0, 0, 0, .8)" :size="90" class="mr5-l mr2"></circle-progress>
    </div>
    <div :class="{'dn-ns mr5-l': !inHome}">
      <circle-progress :percent="artist.percent" emptyFill="rgba(0, 0, 0, .8)" :size="60" class="mr2"></circle-progress>
    </div>
  </div>
</template>

<script>
import ArtistData from '@/components/charts/ArtistData'
import CircleProgress from '@/components/charts/CircleProgress'
import consts from '@/consts'

export default {
  name: 'vinyl-contest-podium',
  props: {
    artist: {
      required: true
    },
    index: {
      required: true
    },
    inHome: {
      default: false
    }
  },
  components: {
    ArtistData,
    CircleProgress
  },
  computed: {
    picture () {
      return consts.MEDIA_BASE_URL + this.artist.path + this.artist.picture
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .image-container {
    height: 100px;
    width: 100px;
  }

  .home-image-container {
    height: 75px;
    width: 75px;
  }

  .artist-info {
    max-width: 40vw;
  }

  .artist-info-home {
    max-width: 8vw;
    min-width: 8vw;
  }

  @media screen and (min-width: 1024px) {
    .artist-info {
      max-width: 50vw;
    }
  }

  @media screen and(max-width: 959px) {
    .artist-info-home {
      max-width: 50vw;
    }
  }

  @media screen and (max-width: 768px) {
    .artist-info {
      max-width: 30vw;
    }
  }

  @media screen and (max-width: 479px) {
    .image-container {
      height: 90px;
      width: 90px;
    }
    .artist-info-home {
      max-width: 30vw;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/charts/VinylContestPodium.vue